import { MaskedTaxIDTextInput } from "cerulean";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface TaxIDInputProps<T extends FieldValues> {
  control: Control<T, unknown>;
  name: Path<T>;
  label: string;
  isInitiallyMasked?: boolean;
  tooltipText?: string;
}

function TaxIDInput<T extends FieldValues>(props: TaxIDInputProps<T>) {
  const { control, name, label, tooltipText, ...inputProps } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => {
        return (
          <MaskedTaxIDTextInput
            isInitiallyMasked={props.isInitiallyMasked ?? false}
            label={label}
            tooltipText={tooltipText}
            onChange={onChange}
            onBlur={onBlur}
            value={value ?? ""}
            error={error?.message}
            ref={ref}
            {...inputProps}
          />
        );
      }}
    />
  );
}

export { TaxIDInput };
